import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";

function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const languages = [
    { code: "en", name: "English", flag: "/usa.webp" },
    { code: "al", name: "Shqip", flag: "/albania.png" },
  ];

  const currentLanguage = languages.find((lang) => lang.code === i18n.language);

  const handleLanguageChange = (langCode) => {
    i18n.changeLanguage(langCode);
    setIsOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
  };
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
    <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center px-3 py-2 rounded-lg hover:bg-gray-100 transition-all"
        title={currentLanguage?.name}
      >
        <img
          src={currentLanguage?.flag}
          alt={currentLanguage?.name}
          className="w-8 h-6 object-cover rounded"
        />
      <svg
          className={`ml-2 w-4 h-4 transition-transform ${
            isOpen ? "rotate-180" : ""
          }`}
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
            d="M19 9l-7 7-7-7"
        />
      </svg>
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-40 bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-50">
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => handleLanguageChange(lang.code)}
              className={`w-full flex items-center px-4 py-2 hover:bg-gray-100 transition-colors ${
                i18n.language === lang.code ? "bg-gray-50" : ""
              }`}
            >
              <img
                src={lang.flag}
                alt={lang.name}
                className="w-8 h-6 object-cover rounded"
              />
              <span className="ml-3 text-sm font-medium text-gray-700">
                {lang.name}
      </span>
              {i18n.language === lang.code && (
                <svg
                  className="ml-auto w-4 h-4 text-green-600"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              )}
    </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default LanguageSwitcher;
